<template>
    <PainelGrafico
        titulo="Produtos Vendidos"
        v-model:aberto="mostrarGrafico"
        :carregando="carregando"
        :vazio="!carregando && (!data || !data.length)"
        :dica="mes == null ? 'Clique em um mês para ver as semanas' : ''"
    >
        <template #info>
            <v-menu location="end">
                <template v-slot:activator="{ props }">
                    <i v-bind="props" class="bi bi-info-circle" title="Sobre o indicador"></i>
                </template>
                <v-card min-width="100" style="max-width: 23rem; padding: 1rem">
                    <div>
                        <b>Fórmula:</b> Soma da quantidade de itens vendidos no período.<br>
                        <b>Polaridade:</b> Quanto maior, melhor.<br>
                        <b>Fonte:</b> OMIE > Produtos > Pedido-Compra (etapa faturado).<br>
                        <b>Descrição:</b> Quantidade de produtos vendidos, filtrável por família.
                    </div>
                </v-card>
            </v-menu>
        </template>

        <template #filtros>
            <div>
                <label for="familia-produtos">Família do produto</label>
                <select id="familia-produtos" v-model="familiaSelecionada" @change="getDados()">
                    <option>Todos</option>
                    <option v-for="(i, index) in listaFamilias" :key="index">{{ i }}</option>
                </select>
            </div>
        </template>

        <Bar
            :options="dadosGrafico().options"
            :data="dadosGrafico().data"
            ref="barChart"
        />
    </PainelGrafico>
</template>

<script>
import serviceGraficos from '@/services/serviceGraficos.js';
import { Bar } from 'vue-chartjs';
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js';
import { getRelativePosition } from 'chart.js/helpers';
import PainelGrafico from '@/components/PainelGrafico.vue';
import { getChartTheme, baseChartOptions } from '@/utils/chartTheme';

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale);

export default {
    name: 'GraficoProdutosVendidos',
    components: { Bar, PainelGrafico },
    props: {
        mes: { required: true },
        ano: { required: true },
    },
    emits: ['updateMes'],
    data() {
        return {
            data: null,
            mostrarGrafico: true,
            carregando: true,
            listaFamilias: [],
            familiaSelecionada: 'Todos',
        };
    },
    watch: {
        mes: 'getDados',
        ano: 'getDados',
    },
    mounted() {
        this.getFamilias();
    },
    methods: {
        async getFamilias() {
            try {
                this.listaFamilias = await serviceGraficos.getFamilias();
                await this.getDados();
            } catch (error) {
                console.error('Erro ao obter familias:', error);
                this.carregando = false;
            }
        },
        async getDados() {
            this.carregando = true;
            try {
                this.data = await serviceGraficos.getProdutosVendidos(
                    this.familiaSelecionada,
                    this.mes,
                    this.ano
                );
            } catch (error) {
                console.error('Erro ao obter dados:', error);
                this.data = [];
            } finally {
                this.carregando = false;
            }
        },
        dadosGrafico() {
            const theme = getChartTheme();
            const options = baseChartOptions({
                ...theme,
                onClick: (e) => {
                    if (this.mes != null || !this.$refs.barChart?.chart) return;
                    const canvasPosition = getRelativePosition(e, this.$refs.barChart.chart);
                    const dataX = this.$refs.barChart.chart.scales.x.getValueForPixel(canvasPosition.x);
                    if (dataX != null && dataX >= 0) {
                        this.$emit('updateMes', dataX + 1);
                    }
                },
            });

            return {
                data: {
                    datasets: [{
                        label: 'Quantidade vendida',
                        backgroundColor: '#db6363',
                        borderRadius: 4,
                        data: this.data || [],
                    }],
                },
                options,
            };
        },
    },
};
</script>
